module.exports = __webpack_public_path__ + "resources/img/equipment_tab4_img5_m.bbcbf755effd7c5886a765438210cc08.jpg";